import React, { useState, useEffect } from 'react';

const ProductsPageHero = ({ selectedCategory }) => {
  const [offsetY, setOffsetY] = useState(0);
  const handleScrollOurStory = () => setOffsetY(window.pageYOffset);

  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', handleScrollOurStory);

    return () => window.removeEventListener('scroll', handleScrollOurStory);
  }, []);
  return (
    <div
      className='products-page-top'
      style={{
        transform: `translateY(${offsetY * -0.2}px)`,
        overflow: 'hidden',
      }}
    >
      <div className='products-page-top-inner'>
        <div
          style={{
            transform: `translateY(${offsetY * -0.6}px)`,
          }}
        >
          <h2>
            All {selectedCategory !== 'All' ? selectedCategory : null} Products
          </h2>
        </div>
      </div>
    </div>
  );
};

export default ProductsPageHero;
